import { render, staticRenderFns } from "./ItemApresentacao.vue?vue&type=template&id=afeea94a&scoped=true&"
import script from "./ItemApresentacao.vue?vue&type=script&lang=js&"
export * from "./ItemApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./ItemApresentacao.vue?vue&type=style&index=0&id=afeea94a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeea94a",
  null
  
)

export default component.exports